@if (node?.restricted) {
    <div [class]="containerClass + ' btn-group '">
        @if ((appSharedFacade.canReadNode$(node?.id) | async) !== true) {
            <button type="button" class="btn btn-dark btn-sm" [title]="'restricted_content_message' | translate">
                <span class="fa fa-lock"></span>
            </button>
            @if (appSharedFacade.currentUser$ | async) {
                <a class="btn btn-secondary btn-sm" [href]="shopConfig.url + '?instance=' + shopConfig.instanceKey + '&id=' + node?.id" target="_blank">{{ 'get_access' | translate }}</a>
            } @else {
                <a type="button" class="btn btn-secondary btn-sm" [href]="authControlService.getOidcAuthLoginUrl()">{{ 'sign_in' | translate }}</a>
            }
        } @else {
            <button type="button" class="btn btn-dark btn-sm" [title]="'restricted_content_message' | translate">
                <span class="fa fa-lock-open"></span>
            </button>
        }
    </div>
}